import { render, staticRenderFns } from "./commissionList.vue?vue&type=template&id=b8d21108&scoped=true&"
import script from "./commissionList.vue?vue&type=script&lang=js&"
export * from "./commissionList.vue?vue&type=script&lang=js&"
import style0 from "./commissionList.vue?vue&type=style&index=0&id=b8d21108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d21108",
  null
  
)

export default component.exports